// extracted by mini-css-extract-plugin
module.exports = {"inline-hyperlink":"InlineHyperlink_inline-hyperlink__1lx8A","inline-hyperlink-printable":"InlineHyperlink_inline-hyperlink-printable__3SCzW"};